<template>
  <div class="container swiper-container slide2">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        data-swiper-autoplay="3000"
        v-for="product in productList"
        :key="product.productsId"
      >
        <a
          href=""
          class="btn_detail"
          @click.prevent="
            $router.push({
              name: 'ProductDetail',
              params: { productId: product.productsId },
            })
          "
        >
          <img
            :src="product.productsMainImageUrl"
            class="img"
            alt=""
          />
          <div class="contents">
            <p class="txt">
              {{ product.mainPageContents }}
            </p>
            <h2 class="tit white-space--pre">{{ product.mainPageKoreanName }}</h2>
          </div>
        </a>
      </div>
    </div>
    <div class="btn_controllLR">
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="swiper-scrollbar"></div>
  </div>
</template>

<script>
export default {
  name: 'ScrollProductsSection',
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
